import s from './BundleContent.module.scss';
import { ReactComponent as SvgFade } from '../../../aassets/ic/ui/fade-cover.svg';
import cn from 'classnames';
interface Props {
    content: string;
    show: boolean;
}
const BundleContent = ({ content, show }: Props) => {
    return (
        <div
            className={cn(s.rt, {
                [s.rt_hide]: !show,
            })}
        >
            <div
                className={`sun-editor-editable se-rtl ${s.rt_cnt} ims`}
                dangerouslySetInnerHTML={{ __html: content }}
            />
            {!show && <SvgFade />}
        </div>
    );
};
export default BundleContent;
